// Java's String.hashCode() algorithm, using Math.imul for correct 32-bit multiplication —
// same result as the shift-based version in chainalysis/reactor, just via the modern API.
export const hashCode = (input: string): number => {
  let hash = 0;
  for (let i = 0; i < input.length; i += 1) {
    // oxlint-disable-next-line unicorn/prefer-math-trunc
    hash = (Math.imul(31, hash) + input.charCodeAt(i)) | 0;
  }
  return hash;
};
